import { VAlert } from 'vuetify/lib/components/VAlert';

var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',[(_vm.withLine)?_c(VAlert,{attrs:{"type":"info","outlined":""}},[_vm._v("While the optimal route has been calculated, only straight lines are shown between stops on the map ")]):_vm._e(),_c('div',{staticClass:"px-2",staticStyle:{"height":"600px","width":"100%"},attrs:{"id":"mapContainer"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }